"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9875],{

/***/ 43388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var CustomRadio = function(_param) {
    var _className = _param.className, className = _className === void 0 ? "" : _className, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "className"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        className: "custom-radio ".concat(className ? className : ""),
        type: "radio"
    }, props));
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomRadio);


/***/ }),

/***/ 29875:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(58165);
/* harmony import */ var _redux_actions__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(19372);
/* harmony import */ var _utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8824);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(74118);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(25617);
/* harmony import */ var src_config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77733);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(70145);
/* harmony import */ var _utils_deviceInfo__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90864);
/* harmony import */ var _assets_svgExports_BackArrow__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85946);
/* harmony import */ var _CustomRadio__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43388);
/* harmony import */ var _Common_Toast__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(40804);
// styling for this component is in emiCardPayment.scss


















var rangeOfYears = function() {
    var result = [];
    var min = new Date().getUTCFullYear();
    var max = min + 20;
    while(min <= max){
        result.push("" + min);
        min++;
    }
    return result;
};
var EmiCardPayment = function(param) {
    var _isDesktop = param.isDesktop, isDesktop = _isDesktop === void 0 ? true : _isDesktop;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        cardInformation: {
            cardNumber: "",
            monthSelected: "01",
            yearSelected: rangeOfYears()[0],
            cvv: ""
        },
        cvvLength: 3,
        selectedEmi: {},
        step: 1,
        completedSteps: [],
        cardType: "",
        emiAvailable: true
    }), emiInformation = ref[0], setEmiInformation = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(0), openEmiOption = ref1[0], setOpenEmiOption = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)({
        isCardNumberValid: true,
        isCardCVVInvalid: false
    }), cardValidation = ref2[0], setCardValidation = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(false), showCvvShowcase = ref3[0], setShowCvvShowcase = ref3[1];
    var ref4 = (0,react_redux__WEBPACK_IMPORTED_MODULE_4__/* .useSelector */ .v9)(function(state) {
        return {
            store: state.storeReducer.store,
            orderDetails: state.orderReducer.orderDetails,
            emiOptionsForCard: state.emiReducer.emiOptionsForCard,
            userData: state.userReducer
        };
    }), emiOptionsForCard = ref4.emiOptionsForCard, userData = ref4.userData, orderDetails = ref4.orderDetails, store = ref4.store;
    var toggleCvvPopup = function() {
        setShowCvvShowcase(function(s) {
            return !s;
        });
    };
    var inputChange = function(value, type) {
        var tempState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, emiInformation), {
            cardInformation: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, emiInformation.cardInformation)
        });
        var tempCardValidation = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, cardValidation);
        switch(type){
            case "cardNo":
                {
                    tempCardValidation.isCardNumberValid = true;
                    if (value.length <= 20) {
                        tempState.cardInformation.cardNumber = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__/* .cardNumberFormat */ .XW)(value.trim());
                        tempState.cardType = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__/* .getCardType */ .C1)(value.trim());
                        tempState.emiAvailable = true;
                        tempState.cvvLength = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__/* .getCardType */ .C1)(tempState.cardInformation.cardNumber) === _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .CARD_TYPE.AMEX */ .WK.AMEX ? 4 : 3;
                        debounceOnChange(value.trim());
                    }
                    break;
                }
            case "cardMonth":
                {
                    tempState.cardInformation.monthSelected = value;
                    break;
                }
            case "cardYear":
                {
                    tempState.cardInformation.yearSelected = value;
                    break;
                }
            case "cvv":
                {
                    tempCardValidation.isCardCVVInvalid = false;
                    if (value.length <= emiInformation.cvvLength) {
                        tempState.cardInformation.cvv = value;
                    }
                }
            default:
                break;
        }
        setEmiInformation(function(state) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state, tempState);
        });
        setCardValidation(function(state) {
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state, tempCardValidation);
        });
    };
    var validateCardNumber = function(number) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, cardValidation);
        newState["isCardNumberValid"] = (0,_utils_cardTypeValidator__WEBPACK_IMPORTED_MODULE_1__/* .isCardValid */ .TH)(number);
        setCardValidation(newState);
    };
    var validateCardCVV = function(number) {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, cardValidation);
        newState["isCardCVVInvalid"] = number.length !== emiInformation.cvvLength ? "Enter valid CVV" : false;
        setCardValidation(newState);
    };
    var validateAll = function() {
        var newState = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, cardValidation);
        var isAllValid = true;
        if (!emiInformation.cardInformation.cardNumber) {
            newState["isCardNumberValid"] = false;
            isAllValid = false;
        }
        if (emiInformation.cvvLength !== emiInformation.cardInformation.cvv.length) {
            newState["isCardCVVInvalid"] = "Enter a valid CVV";
            isAllValid = false;
        }
        setCardValidation(newState);
        return isAllValid;
    };
    var handleCardNumberChange = function(value) {
        if (value.length >= 6) {
            var callback = function(emiOptionAvailable) {
                setEmiInformation(function(state) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                        emiAvailable: emiOptionAvailable
                    });
                });
            };
            /**
       * change card_number in obj to allow only the first 6 digits
       * in card number to be sent as payload for initiatePayment api
       */ dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_13__/* .getEmiOptionsSpecificToCard */ .L1)({
                store_id: store === null || store === void 0 ? void 0 : store.store_id,
                hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                card_number: value.substring(0, 6)
            }, callback));
        }
    };
    var debounceOnChange = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)((0,_utils_debounce__WEBPACK_IMPORTED_MODULE_14__/* .debounce */ .D)(handleCardNumberChange, 500), []);
    var completeEmiSteps = function(step) {
        if (!emiInformation.emiAvailable || emiInformation.cardInformation.cardNumber === "" || emiInformation.cardInformation.cardNumber.split(" ").join("").length < 14) return;
        var tempCompletedSteps = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(emiInformation.completedSteps);
        tempCompletedSteps.push(step);
        var newStepCount = emiInformation.step === 3 ? 3 : emiInformation.step + 1;
        setEmiInformation(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                completedSteps: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(new Set(tempCompletedSteps)),
                step: newStepCount
            });
        });
    };
    var editEmiSteps = function(step) {
        setEmiInformation(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                completedSteps: step === 1 ? [] : [
                    1
                ],
                step: step
            });
        });
    };
    var selectEmiPlanBtnClick = function(emiPlan) {
        setEmiInformation(function(state) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, state), {
                selectedEmi: emiPlan
            });
        });
        var payload = {
            order_hash: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
            store_id: store === null || store === void 0 ? void 0 : store.store_id,
            emi_option: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, emiPlan)
        };
        var callback = function(status) {
            if (status) {
                completeEmiSteps(2);
            } else {
                (0,_Common_Toast__WEBPACK_IMPORTED_MODULE_10__/* .toastNotifyError */ .Lu)("Cannot select emi plan currently");
            }
        };
        dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_13__/* .setEmiOptions */ .ZZ)(payload, callback));
    };
    var emiStepCompletionForMobile = function() {
        switch(emiInformation.step){
            case 1:
                completeEmiSteps(1);
                break;
            case 3:
                completeEmiPaymentInit();
                break;
            default:
                break;
        }
    };
    var disabilityOfMobileButton = function() {
        switch(emiInformation.step){
            case 1:
                return !(emiInformation.cardInformation.cardNumber.length >= 16) || !emiInformation.emiAvailable;
            case 3:
                return emiInformation.cardInformation.cvv.length !== emiInformation.cvvLength;
            default:
                return true;
        }
    };
    var CompletedStepComponent = function(param) {
        var children = param.children;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "emi-step-completed",
            children: children
        });
    };
    var completeEmiPaymentInit = function() {
        if (validateAll()) {
            var ref, ref1;
            var data = {
                orderID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_hash,
                paymentMethod: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .PAYMENT_TYPE_CONSTANTS.EMI */ .Mf.EMI,
                merchantID: orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.merchant_id,
                deviceType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_7__/* .getDeviceInfo */ .d)().OSName,
                browserType: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_7__/* .getDeviceInfo */ .d)().BrowserName,
                userAgent: (0,_utils_deviceInfo__WEBPACK_IMPORTED_MODULE_7__/* .getDeviceInfo */ .d)().userAgent,
                source: "longtail",
                cNum: emiInformation.cardInformation.cardNumber.split(" ").join(""),
                cCvv: emiInformation.cardInformation.cvv,
                cName: "DOTPE",
                cExpMonth: emiInformation.cardInformation.monthSelected,
                cExpYear: emiInformation.cardInformation.yearSelected,
                merchantName: "Digital Showroom - ".concat(store === null || store === void 0 ? void 0 : (ref = store.store_info) === null || ref === void 0 ? void 0 : ref.name),
                emiCode: emiInformation.selectedEmi.emi_code,
                phone: userData === null || userData === void 0 ? void 0 : (ref1 = userData.data) === null || ref1 === void 0 ? void 0 : ref1.phone
            };
            var encryptCCDetails = (0,_utils_encryptionDecryption__WEBPACK_IMPORTED_MODULE_16__/* .getEncrypDecryptStr */ .v)(JSON.stringify(data), "encrypt");
            localStorage === null || localStorage === void 0 ? void 0 : localStorage.setItem("dscc", JSON.stringify(encryptCCDetails));
            dispatch((0,_redux_actions__WEBPACK_IMPORTED_MODULE_17__/* .initPayment */ .yK)(data, router));
        }
    };
    var cardBaseErrorMessage = function() {
        if (!emiInformation.emiAvailable) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                className: "error",
                children: "No EMI option available for this Bank, please try different card"
            });
        }
        if (!cardValidation.isCardNumberValid) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                className: "error",
                children: "Enter valid card number"
            });
        }
        return null;
    };
    var affirmationButton = function(param) {
        var _onClick = param.onClick, onClick = _onClick === void 0 ? null : _onClick, _disabled = param.disabled, disabled = _disabled === void 0 ? false : _disabled, _label = param.label, label = _label === void 0 ? "Continue" : _label, _showButton = param.showButton, showButton = _showButton === void 0 ? true : _showButton;
        if (!showButton) return null;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
            disabled: disabled,
            className: "pointer dib affirmation-btn fw6-ns fw5 br-pill ".concat(disabled ? "o-30" : ""),
            onClick: onClick,
            children: label
        });
    };
    var EditButton = function(param) {
        var _onClick = param.onClick, onClick = _onClick === void 0 ? undefined : _onClick, _label = param.label, label = _label === void 0 ? "" : _label, _customStyle = param.customStyle, customStyle = _customStyle === void 0 ? {} : _customStyle;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
            className: "relative pointer dib edit-btn br-pill",
            onClick: onClick,
            style: customStyle,
            children: label !== null && label !== void 0 ? label : "Edit"
        });
    };
    /**
   * Function to change all characters in the card number
   * after the 6th digit into 'X', 1st step is completed
   * @return {string} morphed car number
   */ var cardNumberRenderAfterStep1 = function() {
        // here slice starts at 7th inex due to 1 space between card number blocks
        var firstSixChar = emiInformation.cardInformation.cardNumber.substring(0, 7);
        var mappedLastChars = emiInformation.cardInformation.cardNumber.slice(7).split(" ");
        var morphString = mappedLastChars.map(function(value) {
            return value.replace(/./gi, "X");
        });
        return "".concat(firstSixChar).concat(morphString.join(" "));
    };
    var cardInformationSection = function() {
        var ref;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mb4-ns",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "emiCardPayment__header",
                    children: "Enter Credit or Debit card details"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "card-information-section flex ".concat(isDesktop ? "flex-row" : "flex-column"),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "card-information-section--first",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex items-center justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "card-header-text",
                                            children: "Card Number"
                                        }),
                                        !isDesktop && emiInformation.completedSteps.includes(1) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "card-header-edit dib",
                                            onClick: function() {
                                                return editEmiSteps(1);
                                            },
                                            children: "Edit Card"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "relative",
                                    children: [
                                        emiInformation.completedSteps.includes(1) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompletedStepComponent, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "mv0",
                                                children: cardNumberRenderAfterStep1()
                                            })
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                                                    type: "tel",
                                                    className: "emi-input w-100 ".concat(!emiInformation.emiAvailable || !cardValidation.isCardNumberValid ? "invalid" : ""),
                                                    value: emiInformation.cardInformation.cardNumber,
                                                    placeholder: "XXXX XXXX XXXX XXXX",
                                                    onChange: function(e) {
                                                        return inputChange(e.target.value.replace(/[^0-9]/g, ""), "cardNo");
                                                    },
                                                    onBlur: function(e) {
                                                        return validateCardNumber(e.target.value.replace(/[^0-9]/g, ""));
                                                    }
                                                }),
                                                cardBaseErrorMessage()
                                            ]
                                        }),
                                        (emiInformation === null || emiInformation === void 0 ? void 0 : emiInformation.cardType) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            className: "card-image",
                                            loading: "lazy",
                                            src: _utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .cc_icons */ .P2[emiInformation.cardType] || src_config__WEBPACK_IMPORTED_MODULE_5__/* ["default"].CDN_SERVER_URL */ .Z.CDN_SERVER_URL + "image/ic-credit-card.svg",
                                            alt: "cardType"
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "card-information-section--second flex flex-column justify-end",
                            children: emiInformation.completedSteps.includes(1) ? isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditButton, {
                                label: "Edit Card",
                                customStyle: {
                                    bottom: 8
                                },
                                onClick: function() {
                                    return editEmiSteps(1);
                                }
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "card-header-text",
                                        children: "Expiry Date"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex items-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "relative mr3",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                                        value: emiInformation.cardInformation.monthSelected,
                                                        className: "emi-select",
                                                        onChange: function(e) {
                                                            return inputChange(e.target.value, "cardMonth");
                                                        },
                                                        children: Array.from(Array(12).keys()).map(function(arr) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                children: "".concat(+arr + 1 < 10 ? "0" : "").concat(arr + 1)
                                                            }, arr);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        alt: "dropdown button",
                                                        src: "/assets/images/down-arrow-thin.svg"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                className: "relative",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                                                        value: emiInformation.cardInformation.yearSelected,
                                                        className: "emi-select",
                                                        onChange: function(e) {
                                                            return inputChange(e.target.value, "cardYear");
                                                        },
                                                        children: (ref = rangeOfYears()) === null || ref === void 0 ? void 0 : ref.map(function(range) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("option", {
                                                                children: range
                                                            }, range);
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        alt: "dropdown button",
                                                        src: "/assets/images/down-arrow-thin.svg"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                (!emiInformation.completedSteps.includes(1) || emiInformation.step === 1) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "flex justify-end",
                    style: {
                        marginTop: 25
                    },
                    children: affirmationButton({
                        showButton: isDesktop,
                        disabled: !(emiInformation.cardInformation.cardNumber.length >= 16) || !emiInformation.emiAvailable,
                        onClick: function() {
                            return completeEmiSteps(1);
                        }
                    })
                })
            ]
        });
    };
    var emiSelectionComponent = function() {
        var ref, ref1, ref2;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "emi-selection-section mb4-ns",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center justify-between",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                            className: "emiCardPayment__header",
                            children: "Select EMI Tenure"
                        }),
                        !isDesktop && emiInformation.completedSteps.includes(2) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            className: "card-header-edit dib",
                            onClick: function() {
                                return editEmiSteps(2);
                            },
                            children: "Edit Tenure"
                        })
                    ]
                }),
                emiInformation.completedSteps.includes(2) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "card-information-section--first",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CompletedStepComponent, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                    className: "mv0",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                            children: [
                                                src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                (emiInformation === null || emiInformation === void 0 ? void 0 : (ref = emiInformation.selectedEmi) === null || ref === void 0 ? void 0 : ref.payable_emi_value) || ""
                                            ]
                                        }),
                                        " ",
                                        "X ",
                                        emiInformation === null || emiInformation === void 0 ? void 0 : (ref1 = emiInformation.selectedEmi) === null || ref1 === void 0 ? void 0 : ref1.tenure,
                                        " | Total Cost - ",
                                        src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                        emiInformation === null || emiInformation === void 0 ? void 0 : (ref2 = emiInformation.selectedEmi) === null || ref2 === void 0 ? void 0 : ref2.total_payable_amount
                                    ]
                                })
                            })
                        }),
                        isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "card-information-section--second flex flex-column justify-end",
                            style: {
                                paddingLeft: 0
                            },
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(EditButton, {
                                label: "Edit Tenure",
                                onClick: function() {
                                    return editEmiSteps(2);
                                }
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "overflow-hidden",
                    style: {
                        border: "0.4px solid #D6D6D6",
                        borderRadius: 7
                    },
                    children: (emiOptionsForCard === null || emiOptionsForCard === void 0 ? void 0 : emiOptionsForCard.length) > 0 && (emiOptionsForCard === null || emiOptionsForCard === void 0 ? void 0 : emiOptionsForCard.map(function(emi, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "emi-option-accordion",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "emi-option-accordion__header flex items-center pointer",
                                    onClick: function() {
                                        return setOpenEmiOption(index);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomRadio__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                            readOnly: true,
                                            className: "mr3 ultramarine-blue-color",
                                            type: "radio",
                                            checked: openEmiOption === index,
                                            onChange: undefined
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                            className: "mv0",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                    className: "fw6",
                                                    children: [
                                                        src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                        emi.payable_emi_value
                                                    ]
                                                }),
                                                " ",
                                                "X ",
                                                emi.tenure,
                                                " | Total Cost - ",
                                                src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                emi.total_payable_amount
                                            ]
                                        })
                                    ]
                                }),
                                openEmiOption === index && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "emi-option-accordion__body",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("table", {
                                            className: "emi-table w-100",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("thead", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: isDesktop ? "EMI per month" : "EMI Plan"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: isDesktop ? "Interest" : "Interest(pa)"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("th", {
                                                                children: isDesktop ? "Total EMI Cost" : "Total Cost"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("tbody", {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("td", {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("b", {
                                                                    className: "fw6",
                                                                    children: [
                                                                        src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                                        emi.payable_emi_value
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                                children: [
                                                                    src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                                    emi.total_emi_interest_paid,
                                                                    "(",
                                                                    emi.emi_bank_interest,
                                                                    "%)"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("td", {
                                                                children: [
                                                                    src_config__WEBPACK_IMPORTED_MODULE_5__/* .CURRENCY_SYMBOL */ .o,
                                                                    emi.total_payable_amount
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "tr-ns tc pt24px",
                                            children: affirmationButton({
                                                label: "Select EMI Plan",
                                                onClick: function() {
                                                    return selectEmiPlanBtnClick(emi);
                                                }
                                            })
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    }))
                })
            ]
        });
    };
    var cvvShowcasePopup = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "cvvShowcasePopup z-5",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: "The CVV number is the last three digits at the back of your card."
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: "https://cdn.dotpe.in/longtail/themes/8073865/HfkWWY3g.webp"
                })
            ]
        });
    };
    var checkForValidCVV = function() {
        return emiInformation.cardInformation.cvv.length !== 0 && cardValidation.isCardCVVInvalid;
    };
    var cardCvvInput = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mb4 relative",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                    className: "emiCardPayment__header relative flex items-center",
                    children: [
                        "Enter CVV",
                        " ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                            src: "/assets/images/info-icon-grey.svg",
                            onMouseOver: toggleCvvPopup,
                            onMouseOut: toggleCvvPopup
                        })
                    ]
                }),
                showCvvShowcase && cvvShowcasePopup(),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex items-center relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "tel",
                            className: "emi-input mr3 w-20-ns w-40 ".concat(checkForValidCVV() ? "invalid" : ""),
                            value: emiInformation.cardInformation.cvv,
                            onChange: function(e) {
                                return inputChange(e.target.value.replace(/[^0-9]/g, ""), "cvv");
                            },
                            onBlur: function(e) {
                                return validateCardCVV(e.target.value);
                            }
                        }),
                        checkForValidCVV() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("small", {
                            className: "error",
                            children: cardValidation.isCardCVVInvalid
                        }),
                        affirmationButton({
                            showButton: isDesktop,
                            disabled: emiInformation.cardInformation.cvv.length !== emiInformation.cvvLength,
                            onClick: completeEmiPaymentInit
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "emiCardPayment",
        children: [
            !isDesktop && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "page-header flex items-center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_assets_svgExports_BackArrow__WEBPACK_IMPORTED_MODULE_8__/* .BackArrow */ .D, {
                        onClick: function() {
                            return router.back();
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "header-text ml3 fw6",
                        children: "EMI"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "emiCardPayment__body",
                children: [
                    cardInformationSection(),
                    emiInformation.step >= 2 && emiSelectionComponent(),
                    emiInformation.step === 3 && cardCvvInput()
                ]
            }),
            !isDesktop && emiInformation.step !== 2 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mobile-affirm-btn-container",
                children: affirmationButton({
                    showButton: !isDesktop,
                    disabled: disabilityOfMobileButton(),
                    onClick: emiStepCompletionForMobile
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (EmiCardPayment);


/***/ })

}]);